import { useLocation } from "react-router-dom";
import clsx from 'clsx';
import { Link } from "react-router-dom";
import { ReactComponent as ChevronDown } from "../../Assets/Icons/chevron_down.svg";

const DesktopNav = ({ navList, toggleDropdown, openedDropdown }) => {
  const { pathname } = useLocation();

  return (
    <ul id="desktop" className=" items-center hidden slg:flex z-50 ">
      {navList?.map((nav) => {
        if (nav?.check && !nav.check()) {
          return null;
        }
        if (nav?.isDropdown) {
          return (
            <li
              onClick={(e) => toggleDropdown(e, nav?.title)}
              key={nav?.title}
              className={clsx({
                "flex items-center cursor-pointer text-xs leading-snug font-semibold tracking-wider pr-10 last:pr-0": true,
                " text-chestNut": pathname.includes(nav?.path),
              })}
            >
              <span className="mr-2">{nav?.title}</span>
              <ChevronDown
                className={clsx({
                  transition: true,
                  "transform -rotate-180 ": openedDropdown === nav?.title,
                })}
              />
            </li>
          );
        }
        return (
          <li
            key={nav?.title}
            className={clsx({
              "cursor-pointer text-xs leading-snug font-semibold tracking-wider pr-10 last:pr-0": true,
              " text-chestNut": pathname.includes(nav?.path),
            })}
          >
            <Link to={nav?.path}>{nav?.title}</Link>
          </li>
        );
      })}
    </ul>
  );
};
 
export default DesktopNav;